/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hub_PersonInputs */

const en_us2_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your sheet`)
};

const pt_br2_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua ficha`)
};

const es_419_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ficha`)
};

const pt_pt2_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua ficha`)
};

const fr_fr2_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta fiche`)
};

const de_de2_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Steckbrief`)
};

const it_it2_profile_hub_person = /** @type {(inputs: Profile_Hub_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda personale`)
};

/**
* | output |
* | --- |
* | "Your sheet" |
*
* @param {Profile_Hub_PersonInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_hub_person = /** @type {((inputs?: Profile_Hub_PersonInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hub_PersonInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_hub_person(inputs)
	if (locale === "es-419") return es_419_profile_hub_person(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_hub_person(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_hub_person(inputs)
	if (locale === "de-DE") return de_de2_profile_hub_person(inputs)
	if (locale === "it-IT") return it_it2_profile_hub_person(inputs)
	return en_us2_profile_hub_person(inputs)
});
export { profile_hub_person as "profile.hub_person" }